// Ring sizes to mm
export const ringSizes = {
  3: 14.1,
  3.5: 14.5,
  4: 14.9,
  4.5: 15.3,
  5: 15.7,
  5.5: 16.1,
  6: 16.5,
  6.5: 16.9,
  7: 17.3,
  7.5: 17.7,
  8: 18.1,
  8.5: 18.5,
  9: 19,
  9.5: 19.4,
  10: 19.8,
  10.5: 20.2,
  11: 20.6,
  11.5: 21,
  12: 21.4,
  12.5: 21.8,
  13: 22.2,
  13.5: 22.6
};

/*
 * Get ring size in mm
 * @param {number} size - Ring size
 * @returns {number} Ring size in mm
 */
export const getRingSize = (size: number): number => {
  return size * 4;
};

export type RingSizes = typeof ringSizes;
export type RingSizeKey = keyof RingSizes;
